import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useToggle } from "react-use";
import { useGetAuthenticatedUserQuery } from "@/api/authentication";
import * as analytics from "@/services/analytics";

const AUTO_REDIRECT_MS = 2 * 60 * 1_000;
const SESSION_EXPIRED_URL = "/pf-auth/logout?next_url=/session-expired";

interface Props {
  onRefresh: () => void;
}

export const SessionTimeoutWarningModal: React.FC<Props> = ({ onRefresh }) => {
  const [isOpen, toggleIsOpen] = useToggle(true);
  const { refetch, isFetching } = useGetAuthenticatedUserQuery();

  React.useEffect(() => {
    analytics.sessionTimeoutWarning();
  }, []);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      document.location.href = SESSION_EXPIRED_URL;
    }, AUTO_REDIRECT_MS);
    return () => clearTimeout(timeout);
  }, []);

  const handleExtend = async () => {
    try {
      await refetch().unwrap();
      onRefresh();
      toggleIsOpen(false);
    } catch {
      document.location.href = SESSION_EXPIRED_URL;
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={toggleIsOpen}>
      <DialogContent className="max-w-[350px]">
        <DialogHeader>
          <DialogTitle>Session Timeout warning</DialogTitle>
          <DialogDescription>Your session will expire in 2 minutes.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={toggleIsOpen}>
            Cancel
          </Button>
          <Button variant="default" onClick={handleExtend} disabled={isFetching}>
            {isFetching ? "Extending..." : "Extend"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
